import { DriverApi } from '../../infrastructure/api';
import { Driver } from '../../domain/entities';

export class SearchDriverUseCase {
    async execute(
        registration: string,
        clientId: number,
        token: string
    ): Promise<Driver | null> {
        if (registration.length < 3) {
            return null;
        }

        return await DriverApi.fetchByRegistrationAndClientId(registration, clientId, token);
    }
}

